var _path, _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDownOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 99,
    viewBox: "0 0 135 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6845 52.8588C16.0279 60.649 20.4084 67.964 25.4164 74.7394C30.4685 81.4684 35.9649 87.7365 42.0704 93.3478C48.136 98.999 54.7495 104.063 61.8638 108.56C69.0031 113.049 76.6104 116.883 84.6882 120.691C75.7315 120.696 66.7879 118.618 58.46 115.05C50.1404 111.468 42.3169 106.491 35.6719 100.226C28.9345 94.0535 23.4376 86.6057 19.2156 78.5976C15.0394 70.5603 12.3079 61.7906 11.6845 52.8588Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2606 50.9727C30.5171 56.9323 34.4664 62.6121 38.7795 67.8768C43.1051 73.1433 47.7541 78.0054 52.6299 82.5931C57.5749 87.1045 62.727 91.4218 68.33 95.3038C73.9055 99.2513 79.8264 102.791 86.0671 106.642C71.3407 106.355 57.1342 99.4859 46.2278 89.4692C35.4573 79.3286 27.548 65.6419 26.2606 50.9727Z",
    fill: "url(#paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5225 48.3157C44.5611 52.6426 48.0328 56.8693 51.7558 60.7853C55.4228 64.7393 59.1023 68.5212 62.9902 72.0888C66.8532 75.6826 70.8656 79.109 75.0959 82.4485C79.2846 85.8773 83.7543 89.0143 88.3467 92.7671C82.4061 92.7135 76.6352 91.1742 71.2663 88.766C65.8932 86.3465 60.9138 83.0118 56.5929 78.9685C52.2405 74.959 48.583 70.2106 45.7562 65.0531C42.9628 59.8658 40.987 54.2408 40.5225 48.3157Z",
    fill: "url(#paint2_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4342 46.4647C59.2715 48.8836 61.8173 51.7401 64.7929 54.2298L73.0952 61.8307L81.3117 69.5267C84.0712 72.21 86.923 74.8903 89.7402 78.3054C85.2979 78.4769 81.145 77.3502 77.2457 75.6948C73.3774 73.9774 69.8135 71.5949 66.7086 68.7198C63.5948 65.8526 60.9734 62.4559 58.9667 58.7317C56.9384 55.0218 55.8362 50.7611 55.4342 46.4647Z",
    fill: "url(#paint3_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.32 43.8962C75.1141 46.2912 78.8276 49.1662 82.4243 52.3842C84.1917 54.0063 85.8335 55.76 87.4181 57.74C88.9771 59.7683 90.5289 61.9049 91.8569 64.8692C88.6275 65.3522 85.7716 64.7317 83.1103 63.7414C80.4747 62.704 78.0844 61.1772 76.0419 59.2776C73.997 57.3804 72.2862 55.1181 71.0481 52.5676C69.878 49.9743 68.98 47.2136 69.32 43.8962Z",
    fill: "url(#paint4_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6334 40.2319C85.0541 40.1658 86.6625 40.5641 88.1161 41.0518C89.5232 41.5753 90.6594 42.272 91.6164 43.1587C92.5745 44.0442 93.3415 45.1292 93.9572 46.4928C94.5438 47.9023 95.0434 49.4798 95.1488 51.9064C92.8609 52.7556 91.0363 52.6519 89.3726 52.2863C87.7391 51.8748 86.332 51.0894 85.1976 50.0181C84.0602 48.9486 83.1854 47.601 82.6662 46.0027C82.1946 44.3687 81.9629 42.5674 82.6334 40.2319Z",
    fill: "url(#paint5_linear)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4457 39.5204C94.2637 38.3384 94.2696 36.4149 95.4594 35.2252C96.6486 34.036 98.5726 34.0294 99.7547 35.2115C100.937 36.3935 100.93 38.3175 99.741 39.5067C98.5512 40.6965 96.6278 40.7025 95.4457 39.5204Z",
    fill: "url(#paint6_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 77.5264,
    y1: 127.853,
    x2: 7.10826,
    y2: 57.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 80.3889,
    y1: 112.32,
    x2: 22.651,
    y2: 54.5822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 83.8424,
    y1: 97.2713,
    x2: 37.7047,
    y2: 51.1336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 86.4757,
    y1: 81.57,
    x2: 53.4023,
    y2: 48.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 90.0736,
    y1: 66.6525,
    x2: 68.3186,
    y2: 44.8976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 94.4378,
    y1: 52.6174,
    x2: 82.3429,
    y2: 40.5224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 95.4457,
    y1: 39.5204,
    x2: 99.7547,
    y2: 35.2115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDownOrange);
export default __webpack_public_path__ + "static/media/LogoDownOrange.c50580b311ce71586a62a39dc3be38ac.svg";
export { ForwardRef as ReactComponent };